import { FC } from 'react';
import { RedesignButton } from '@components/RedesignButton';
import { closeCurrentModalAction } from 'src/redesign/features/Modals/store/reducer';
import { Text } from '@components/Text';
import { useAppDispatch } from 'src/hooks';
import S from './RemoveEventModal.module.scss';
import { showNotification } from 'src/redesign/features/Toast/store/actions';

type Props = {
  deleteEvent?: () => void;
  eventName?: string;
};

export const RemoveEventModal: FC<Props> = ({ deleteEvent, eventName }) => {
  const dispatch = useAppDispatch();
  return (
    <div className={S.removeEventModal}>
      <div className={S.modalContent}>
        <Text className={S.description}>
          This action will permanently delete <b>{eventName}</b> from Ticket Spot. Unlike canceling,
          which keeps the event in your system but marks it as cancelled, deletion completely
          removes the event and all associated data.
        </Text>
      </div>
      <div className={S.controlsContainer}>
        <RedesignButton text onClick={() => dispatch(closeCurrentModalAction())}>
          <Text bold color="brand-400">
            Back
          </Text>
        </RedesignButton>
        <RedesignButton
          onClick={() => {
            deleteEvent && deleteEvent();

            dispatch(
              showNotification({
                detail: `${eventName} has been permanently deleted`,
                severity: 'success',
                life: 5000,
              })
            );
            dispatch(closeCurrentModalAction());
          }}
          variation="primary"
          height={44}
        >
          <Text bold color="white-100">
            Delete Permanently
          </Text>
        </RedesignButton>
      </div>
    </div>
  );
};
